import {
    ActionButton,
    Button,
    ButtonGroup,
    Content,
    Dialog,
    DialogTrigger,
    Divider,
    Heading,
} from '@adobe/react-spectrum';
import React from 'react';
import AddCircle from '@spectrum-icons/workflow/AddCircle';
import { SubmitForm } from '../../submitform/SubmitForm';
import '../../common/searedDialog/searedDialog.css';

export function BreadCrumbImportButton(props) {
    return (
        <DialogTrigger type={'modal'}>
            <ActionButton
                isDisabled={props.isDisabled}
                aria-label="Import new deck"
                UNSAFE_className="bcImportButton"
                data-role={'icon-only'}
            >
                <AddCircle />
            </ActionButton>
            {(close) => (
                <Dialog width={'calc(100vw - 40px)'} maxWidth={800} UNSAFE_className="searedDialog">
                    <Heading>
                        <span className="searedDialog__eyebrow">Import</span>
                        <span className="searedDialog__title">Import a new deck</span>
                        <span className="searedDialog__subtitle">Paste deck link to analyze</span>
                    </Heading>
                    <Divider />
                    <Content>
                        <div className="searedDialog__body">
                            <SubmitForm onStartCallback={close} />
                        </div>
                    </Content>
                    <ButtonGroup>
                        <Button variant="secondary" onPress={close}>
                            Cancel
                        </Button>
                    </ButtonGroup>
                </Dialog>
            )}
        </DialogTrigger>
    );
}
